import { WidgetBase } from "./WidgetBase";
import { WidgetTypes } from "./WidgetTypes";
import { WidgetController } from "../WidgetController";
import { LanguageString } from "../../../Model/LanguageString";
import { PopupGenericDataTableComponent } from "../Popups/PopupGenericDataTableComponent";
import { WidgetGenericDataTableComponent } from "../Components/WidgetGenericDataTableComponent";

export class WidgetGenericDataTableProps {
    public title: LanguageString;
    public apiUrl: string;
    public jsonData: string;
    public availableColumns: string;
    public rowClickUrl: string;
    public fixedLayout?: boolean;
    public settingsName?: string;
    public noClickAction?: boolean;

    constructor() {
        this.title = new LanguageString();
    }
}

/**
 * This widget can be used to display a table of any generic data. It can fetch data via an API call or display static json data.
 * The user can provide a set of columns. When the table is displayed, users can select which columns to display.
 * */
export class WidgetGenericDataTable extends WidgetBase {
    props: WidgetGenericDataTableProps;

    constructor(controller: WidgetController) {
        super(controller, 2, 2);
        this.props = new WidgetGenericDataTableProps();
    }

    getType(): WidgetTypes {
        return WidgetTypes.GenericDataTable;
    }

    loadProps(jsonProps: string): void {
        if (jsonProps && jsonProps.length > 0) {
            this.props = JSON.parse(jsonProps);

            if (this.props.title == null)
                this.props.title = new LanguageString();
        } else
            this.props.title = new LanguageString();
    }

    saveProps(): string {
        return JSON.stringify(this.props);
    }

    createComponent(column: number, row: number, colSpan?: number, rowSpan?: number): HTMLElement {
        this.column = column;
        this.row = row;
        this.colSpan = colSpan ? colSpan : this.minColSpan;
        this.rowSpan = rowSpan ? rowSpan : this.minRowSpan;
        this.component = new WidgetGenericDataTableComponent({
            widget: this,
            title: this.props.title,
            apiUrl: this.props.apiUrl,
            jsonData: this.props.jsonData,
            availableColumns: this.props.availableColumns,
            rowClickUrl: this.props.rowClickUrl,
            settingsName: this.props.settingsName,
            noClickAction: this.props.noClickAction
        });
        return this.component.render();
    }

    showPopup(): void {
        let popup = new PopupGenericDataTableComponent({ widget: this });
        document.body.appendChild(popup.render());
    }
}